// src/CheckoutForm.tsx
import React, { useState, useEffect } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

const CARD_OPTIONS = {
  disableLink: true, // hides “Save with Link”
  style: {
    base: {
      fontSize: "16px",
      fontSmoothing: "antialiased",
    },
    invalid: { color: "#e5424d" },
  },
};

export default function CardForm({
  client_secret,
  initialClientSecret,
  setIsCardValid,
  setCard,
  setStripe,
  selectedCard,
  setSelectedCard,
}) {
  const stripe = useStripe();
  const elements = useElements();

  // track state of card element
  const [isEmpty, setIsEmpty] = useState(true);

  const [isLoading, setIsLoading] = useState(true);

  const [errorMessage, setErrorMessage] = useState();

  // controls re-rendering of card element
  const [cardKey, setCardKey] = useState(0);

  useEffect(() => {
    // 2) Confirm the card payment with the Card Element
    if (!elements) return;
    const card = elements.getElement(CardElement);

    if (!card) return;

    setCard(card);
    setStripe(stripe);
  }, [client_secret, initialClientSecret]);

  // reset CardElement when selected saved card changes
  useEffect(() => {
    if (selectedCard && !isEmpty) {
      setCardKey((prev) => prev + 1); // forces CardElement reset
      setIsEmpty(true); // set to empty since we just reset card
      setIsCardValid(false); // reset valid state
      setErrorMessage(); // clear any previous errors
      setIsLoading(true); // show loading state until card is ready
    }
  }, [selectedCard, isEmpty]);

  const checkValid = (e) => {
    setIsEmpty(e.empty);
    if (selectedCard) setSelectedCard(); // if something is changed on new card, unselect saved card
    setIsCardValid(e && e.complete);
    setErrorMessage(e.error?.message);
  };

  return (
    <>
      <div
        style={{
          padding: 12,
          border: "1px solid",
          borderRadius: 8,
          borderColor: errorMessage ? "#e5424d" : "#e6e8ec",
          backgroundColor: isLoading ? "#e6e8ec" : "",
        }}
      >
        <CardElement
          key={cardKey}
          options={CARD_OPTIONS}
          onReady={() => setIsLoading(false)}
          onChange={(e) => checkValid(e)}
        />
      </div>
      {errorMessage && (
        <span className="small text-danger d-block mt-2">{errorMessage}</span>
      )}
      <span className="small d-block mt-3">
        This card will be automatically saved under the user profile for future
        use.
      </span>
    </>
  );
}
